import { render, staticRenderFns } from "./ra-pagination.vue?vue&type=template&id=09fb65d6&scoped=true"
import script from "./ra-pagination.vue?vue&type=script&lang=js"
export * from "./ra-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb65d6",
  null
  
)

export default component.exports